// import get from "lodash.get";
// import isEmpty from "lodash.isempty";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

const _ = {
  isEmpty,
  get,
};

export default _;
